var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.128,
    height: 47.428,
    viewBox: "0 0 50.128 47.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7846",
    "data-name": "Group 7846",
    transform: "translate(-1503.348 402.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12083",
    "data-name": "Path 12083",
    d: "M1507.119-333.425c-.513.163-.958.315-1.409.447a1.786,1.786,0,0,1-2.258-1.089,1.733,1.733,0,0,1,1.091-2.248q2.854-1.009,5.737-1.935a1.683,1.683,0,0,1,2.2,1.071q1.023,2.882,1.944,5.8a1.719,1.719,0,0,1-1.147,2.216,1.777,1.777,0,0,1-2.233-1.137c-.156-.42-.29-.848-.456-1.336a3.9,3.9,0,0,0-.7,1.3c-2.721,7.09-2,13.832,2.553,19.9,4.577,6.1,10.9,8.538,18.46,7.777a18.824,18.824,0,0,0,7.184-2.328,1.817,1.817,0,0,1,2.492.361,1.842,1.842,0,0,1-.358,2.547,8.081,8.081,0,0,1-2.487,1.345,23.743,23.743,0,0,1-31.2-12.709,23.332,23.332,0,0,1,.319-19.144A1.539,1.539,0,0,0,1507.119-333.425Z",
    transform: "translate(0 -56.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12084",
    "data-name": "Path 12084",
    d: "M1638.481-367.844c.521-.164.987-.328,1.462-.457a1.772,1.772,0,0,1,2.2,1.1,1.732,1.732,0,0,1-1.076,2.257q-2.884,1.019-5.8,1.934a1.67,1.67,0,0,1-2.172-1.126c-.66-1.885-1.3-3.778-1.908-5.681a1.756,1.756,0,0,1,1.131-2.283,1.788,1.788,0,0,1,2.258,1.2c.159.444.3.894.462,1.374.318-.136.362-.422.465-.646a20.139,20.139,0,0,0-12.662-27.792,19.674,19.674,0,0,0-14.825,1.425c-.239.121-.47.257-.711.375a1.8,1.8,0,0,1-2.42-.667,1.779,1.779,0,0,1,.714-2.454,22.5,22.5,0,0,1,5.952-2.368,23.62,23.62,0,0,1,28.01,15.121,23.319,23.319,0,0,1-.876,17.992A1.072,1.072,0,0,0,1638.481-367.844Z",
    transform: "translate(-88.775 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12085",
    "data-name": "Path 12085",
    d: "M1629.417-260.518a1.5,1.5,0,0,1,.932-1.513,1.617,1.617,0,0,1,1.794.071,40.112,40.112,0,0,1,2.909,2.832c.075.07.145.147.217.22,1.033,1.043,1.024,1.035,2.086-.032q4.007-4.028,8.03-8.04a1.8,1.8,0,0,1,2.364-.282,1.786,1.786,0,0,1,.626,2.142,2.278,2.278,0,0,1-.55.737q-2.661,2.661-5.32,5.325-2.355,2.359-4.708,4.719a1.855,1.855,0,0,1-3,.016c-1.6-1.578-3.185-3.165-4.788-4.737A1.886,1.886,0,0,1,1629.417-260.518Z",
    transform: "translate(-110.48 -118.101)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.f75a6f9d89250cf6cffbaf3b0eded497.svg";
export { ForwardRef as ReactComponent };